import * as jquery from 'jquery';
import * as q from 'q';

export const Deps = {
    $: jquery
}

class RateLimitAjaxService {
    rateLimitCache: { [id: string]: number } = {};

    ajax<T>(ajaxOptions: JQueryAjaxSettings): Q.Promise<T> {
        var op = q.defer<T>();

        this.doAjax(ajaxOptions, op);

        return op.promise;
    }

    private doAjax<T>(ajaxOptions: JQueryAjaxSettings, op: Q.Deferred<T>) {
        Deps.$.ajax(ajaxOptions)
            .done(result => op.resolve(result))
            .fail(error => {
                if (error.status === 429) {
                    var retryAfter = error.getResponseHeader('Retry-After');
                    if (retryAfter) {
                        if (this.rateLimitCache[ajaxOptions.url]) {
                            clearTimeout(this.rateLimitCache[ajaxOptions.url]);
                        }
                        this.rateLimitCache[ajaxOptions.url] = setTimeout(() => { this.doAjax(ajaxOptions, op) }, parseInt(retryAfter) * 1000);
                    }
                    else {
                        op.reject(error);
                    }
                } else {
                    op.reject(error);
                }
            });
    }
}

var service = new RateLimitAjaxService();
export { service as RateLimitAjaxService };